export const INITIAL_STATE = {
  merchant: null,
  stores: [],
  selectedStore: null,
  localization: {
    digit_separator: ",",
    currency_symbol: "&#163;",
    currency_decimal: true,
    currency_position: "suffix",
  },
  stockTypes: [],
};
